





















































import CommonBase from "../../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";

@Component
export default class InfectionTraceInfoTxt extends CommonBase {
  readonly missingPhoneTo = {name: rd.users.reports.withoutPhone.name};
}
